import { useSpring, animated as a, config } from "@react-spring/web";
import { useEbbnenContext } from "@solidwhite/ebbnen";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import icon1 from "./tutorial_1.svg";
import icon2 from "./tutorial_2.svg";
import icon3 from "./tutorial_3.svg";
import icon4 from "./tutorial_spec.svg";
import Close from "@mui/icons-material/Close";
import { useMultiuserContext } from "@solidwhite/multiuser";

const Tutorial = () => {
  const { currentLayer } = useEbbnenContext();
  const [show, setShow] = useState(true);
  const ref = useRef();
  const { t } = useTranslation();

  const handleClick = () => {
    setShow(false);
  };

  const spring = useSpring({
    opacity: show && currentLayer === 0 ? 1 : 0,
    y: show && currentLayer === 0 ? 0 : 500,
    onRest: () => {
      if (!show && currentLayer > 0) {
        ref.current.style.display = "none";
      }
    },
    onStart: () => {
      if (show && currentLayer === 0) {
        ref.current.style.display = "flex";
      }
    },
    config: config.slow,
  });

  return (
    <a.div
      ref={ref}
      style={{
        ...spring,
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
        // height: "10.8vw",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          color: "rgba(255, 255, 255, 0.25)",
          padding: "0.75vw",
          fontSize: "0.9vw",
          fontWeight: "500",
        }}
      >
        {t("L1_TUTORIAL_HEADLINE")}
      </div>
      <div
        style={{
          pointerEvents: "auto",
          position: "relative",
          display: "flex",
          background: "rgba(255, 255, 255, 0.1)",
          width: "auto",
          maxHeight: "10.75vw",
          padding: "2vw",
          paddingRight: "1vw",
          paddingTop: "0.8vw",
          paddingBottom: "0.3vw",
          cursor: "pointer",
          backdropFilter: "blur(10px)",
          borderRadius: "0.4vw 0.4vw 0 0",
        }}
        onClick={handleClick}
      >
        <TutorialBox>
          <TutorialBoxIcon imgSrc={icon1} />
          <TutorialBoxText>{t("L1_TUTORIAL_TEXT_1")}</TutorialBoxText>
        </TutorialBox>
        <TutorialBox>
          <TutorialBoxIcon imgSrc={icon2} />
          <TutorialBoxText>{t("L1_TUTORIAL_TEXT_2")}</TutorialBoxText>
        </TutorialBox>
        <TutorialBox>
          <TutorialBoxIcon imgSrc={icon3} />
          <TutorialBoxText>{t("L1_TUTORIAL_TEXT_3")}</TutorialBoxText>
        </TutorialBox>
        <Close
          style={{
            position: "absolute",
            top: "0.75vw",
            right: "0.75vw",
            color: "#37a46e",
            width: "1.25vw",
            height: "1.25vw",
          }}
        />
      </div>
    </a.div>
  );
};

export const SpectatorTutorial = () => {
  const [show, setShow] = useState(true);
  const ref = useRef();
  const { t } = useTranslation();

  const handleClick = () => {
    setShow(false);
  };

  const spring = useSpring({
    opacity: show ? 1 : 0,
    y: show ? 0 : 500,
    onRest: () => {
      if (!show) {
        ref.current.style.display = "none";
      }
    },
    onStart: () => {
      if (show) {
        ref.current.style.display = "flex";
      }
    },
    config: config.slow,
  });

  return (
    <a.div
      ref={ref}
      style={{
        ...spring,
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
        // height: "10.8vw",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        zIndex: 9999999,
      }}
    >
      <div
        style={{
          color: "rgba(255, 255, 255, 0.25)",
          padding: "0.75vw",
          fontSize: "0.9vw",
          fontWeight: "500",
        }}
      >
        {t("L1_TUTORIAL_HEADLINE")}
      </div>
      <div
        style={{
          pointerEvents: "auto",
          position: "relative",
          display: "flex",
          background: "rgba(255, 255, 255, 0.1)",
          width: "auto",
          maxHeight: "10.75vw",
          padding: "2vw",
          paddingRight: "1vw",
          paddingTop: "0.8vw",
          paddingBottom: "0.3vw",
          cursor: "pointer",
          backdropFilter: "blur(10px)",
          borderRadius: "0.4vw 0.4vw 0 0",
        }}
        onClick={handleClick}
      >
        <div style={{ display: "flex", width: "auto" }}>
          <span
            style={{
              fontWeight: "light",
              whiteSpace: "pre",
              padding: "0.5vw",
              marginRight: "0.5vw",
              width: "1.75vw",
            }}
          >
            <img src={icon4} style={{ width: "100%", transform: "translate(0%,10%)" }} />
          </span>
          <TutorialBoxText
            style={{
              width: "10vw",
            }}
          >
            {t("MULTIUSER_JOIN_TUTORIAL")}
          </TutorialBoxText>
          <div style={{ width: "1vw" }}></div>
        </div>

        <Close
          style={{
            position: "absolute",
            top: "0.75vw",
            right: "0.75vw",
            color: "#37a46e",
            width: "1.25vw",
            height: "1.25vw",
          }}
        />
      </div>
    </a.div>
  );
};

export const TutorialSwitch = () => {
  const { spectating } = useMultiuserContext();

  if (spectating) {
    return <SpectatorTutorial />;
  } else {
    return <Tutorial />;
  }
};

const TutorialBox = ({ children }) => {
  return <div style={{ display: "flex", width: "12vw" }}>{children}</div>;
};

const TutorialBoxText = ({ children, style }) => {
  return (
    <div
      style={{
        fontSize: "0.725vw",
        color: "white",
        paddingTop: "1vw",
        width: "7vw",
        fontWeight: "300",
        ...style,
      }}
    >
      {children}
    </div>
  );
};

const TutorialBoxIcon = ({ imgSrc }) => {
  return (
    <span
      style={{
        fontWeight: "light",
        whiteSpace: "pre",
        padding: "0.5vw",
        marginRight: "0.5vw",
        width: "1.75vw",
      }}
    >
      <img src={imgSrc} style={{ width: "100%" }} />
    </span>
  );
};

export default Tutorial;
